import version from './version';

export const environment = Object.freeze({
  version: version,
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyDzOKg1DKEL-I4BhmxLdWAwAyz8-tMr-mM',
    authDomain: 'defects-system.firebaseapp.com',
    databaseURL: 'https://defects-system.firebaseio.com',
    projectId: 'defects-system',
    storageBucket: 'defects-system.appspot.com',
    messagingSenderId: '266569484849',
    appId: '1:266569484849:web:f644730093699a74f0e310',
  },
  rollbarKey: 'f3ef67222b58466ea463e13b71e6998d',
  apiBaseUrl: 'https://defectwise-api-apim.azure-api.net/defectwise-api/v1/',
  apiSubscriptionKey: '870b3f9cb66440c5b0fc16b689d12369',
  appStorageAccount: 'https://defectwiseappdata.blob.core.windows.net/',
  reportServerUrl: 'https://server.defectwise.com.au/api/v1/',
  reportSubscriptionKey: '',
  reportAppUrl: 'https://report-builder.defectwise.com.au/',
  ga4measurementTag: 'G-209QR1VMRR',
  mixpanel: '5d1ee17f86c39ae9948890bb4a4093b4',
  webAppBaseRoute: 'https://account.defectwise.com.au/',
  sentryDsn:
    'https://edf4bfa0bde6219c094fadcf166f969c@o941297.ingest.us.sentry.io/4509206432841728',
} as const);
